import { createReducer, on } from '@ngrx/store';
import { Product } from '@models/product.model';
import {
  cannotCreateProduct,
  cannotDeleteProduct,
  cannotFetchProducts,
  cannotUpdateProduct,
  createProduct,
  deleteProduct,
  fetchProducts,
  productCreated,
  productDeleted,
  productsFetched,
  productUpdated,
  setProductDetail,
  updateProduct,
} from '../actions/product.actions';
import { SharedState } from './index';

export interface ProductState extends SharedState {
  products: Product[];
  selectedProduct?: string;
}

export const initialProductState: ProductState = {
  loaded: false,
  isLoading: false,
  error: '',
  products: [],
}

export const productReducer = createReducer(
  initialProductState,
  on(fetchProducts, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(productsFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    products: payload
  })),
  on(cannotFetchProducts, (state, {error}) => ({...state, isLoading: false, loaded: false, error, products: []})),
  on(updateProduct, createProduct, deleteProduct, (state) => ({
    ...state,
    isLoading: true,
    error: '',
    loaded: false
  })),
  on(productUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    products: state.products.map(p => p.id === payload.id ? payload : p)
  })),
  on(productCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    products: [...state.products, payload]
  })),
  on(setProductDetail, (state, {payload}) => ({
    ...state,
    selectedProduct: payload
  })),
  on(productDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    products: state.products.filter(p => p.id !== payload)
  })),
  on(cannotUpdateProduct, cannotCreateProduct, cannotDeleteProduct, (state, {error}) => ({
    ...state,
    isLoading: false,
    loaded: false,
    error
  })),
);
